import { Colors } from "@/enums/Colors";
import { Box, styled } from "@mui/material";

export const Pill = styled(Box, {
  shouldForwardProp: (prop) => prop !== "pillStyles",
})<{
  borderColor?: string;
  backgroundColor?: string;
  pillStyles?: React.CSSProperties;
}>(({ borderColor, backgroundColor, pillStyles }) => ({
  display: "flex",
  alignItems: "center",
  border: `1px solid ${borderColor || Colors.STONE_GRAY}`,
  padding: "0.125rem .5rem 0.125rem .5rem",
  borderRadius: "6.25rem",
  width: "fit-content",
  backgroundColor: `${backgroundColor || "white"}`,
  gap: "0.25rem",
  color: `${Colors.ELEGANT_BLACK}`,
  height: "1.375rem",
  ".pill-text": {
    fontSize: ".75rem",
    fontWeight: "400",
    whiteSpace: "nowrap",
  },
  "& .MuiSvgIcon-root": {
    fontSize: ".75rem",
  },
  ...pillStyles,
}));
